import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { HipoModel } from 'src/app/models/hipo/HipoModel';
import { IPasstRotuloModel } from 'src/app/models/interfaces/passt/IPasstRotuloModel';
import { PasstObtjetivoModel } from 'src/app/models/passt/PasstObtjetivoModel';
import { PasstRotuloModel } from 'src/app/models/passt/PasstRotuloModel';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { PasstService } from 'src/app/services/passt/passt.service';
import { StorageService } from 'src/app/services/storage/storage.service';
import { PasstObjetivoRegistrarDialogComponent } from '../passt-objetivo-registrar-dialog/passt-objetivo-registrar-dialog.component';
import { NgForm } from '@angular/forms';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { ActionResultModel } from 'src/app/models/common/ActionResultModel';
import { eTypeResult } from 'src/app/models/common/enumModel';

@Component({
  templateUrl: './passt-rotulo-editar.component.html',
  styleUrls: ['./passt-rotulo-editar.component.css']
})
export class PasstRotuloEditarComponent implements OnInit {
  id: number;
  model: IPasstRotuloModel;

  displayedColumns: string[] = ['objetivo', 'meta', 'indicador', 'presupuesto', 'recurso', 'acciones'];

  constructor(
    private storage: StorageService,
    public dialog: MatDialog,
    private service: PasstService,
    private router: Router,
    private dialogService: ConfirmDialogService,
    private alertDialogService: AlertDialogService,
    private route: ActivatedRoute,) {
    this.id = 0;
    this.route.params.subscribe((params) => {
      this.id = params['id']; // (+) converts string 'id' to a number

      // In a real app: dispatch action to load the details here.
    });
    this.model=new PasstRotuloModel(); }

  ngOnInit(): void {
    this.service.getById(this.id).subscribe((data: PasstRotuloModel) => {
      this.model = data;
      this.model.editable = true;
    })
  }

  onSubmit(form: NgForm) {
    if (form.invalid) {
      this.alertDialogService.open('Debe ingresar en campos requeridos');
    } else {
      this.dialogService.open('¿Deseas guardar los cambios?'); //options
        this.dialogService.confirmed().subscribe((confirmed) => {
        if (confirmed) {              
              // this.saveData();
            this.submitForm();
          }
        });
    }
  }

  submitForm() {
    this.service.updateRotulo(this.model).subscribe((result : ActionResultModel) => {  
      if(result.type!=eTypeResult.SUCCESS){
        this.alertDialogService.open(result.message);
      }    
      else{  
          this.alertDialogService.open('La información fue registrada.'); //options          
          this.router.navigate(['/passt/seguimiento']);
      }
    });
}

  closed(){
    this.dialogService.open('Se perderán los cambios no guardados ¿esta seguro de salir?'); //options
          this.dialogService.confirmed().subscribe((confirmed) => {
            if (confirmed) {
              this.router.navigate(['/passt/seguimiento']);
            }
          });
  }

  openDialogAccion(item?: PasstObtjetivoModel): void {
    if(item==null)
      item = new PasstObtjetivoModel();
    
    const editData = JSON.parse(JSON.stringify(item));
    // console.log(tipoDocumento);
    const dialogRef = this.dialog.open(PasstObjetivoRegistrarDialogComponent, {
      width: '900px',
      data: editData,
    });

    dialogRef.afterClosed().subscribe((result: PasstObtjetivoModel) => {
      // this.animal = result;
      if (result) {
        if(result.idPasstObjetivo != 0){
          this.model.objetivos[this.model.objetivos.findIndex(item => item.idPasstObjetivo == result.idPasstObjetivo)]=result;
        }
        else if(result.index == 0){
          if(this.model.objetivos.length>0)
            result.index = this.model.objetivos[this.model.objetivos.length-1].index+1;
          else
            result.index = 1;
          this.model.objetivos.push(result);
          
        }
        else{
          this.model.objetivos[this.model.objetivos.findIndex(item => item.index == result.index)]=result;
        }
        const temp =  JSON.stringify(this.model.objetivos);
        this.model.objetivos = JSON.parse(temp);
      }
    });
  }

  eliminarObjetivo(item: PasstObtjetivoModel): void {
    if(item.idPasstObjetivo != 0)
      this.model.objetivos.splice(this.model.objetivos.findIndex(p => p.idPasstObjetivo == item.idPasstObjetivo),1);
    else 
      this.model.objetivos.splice(this.model.objetivos.findIndex(p => p.index == item.index),1);
    const temp =  JSON.stringify(this.model.objetivos);
    this.model.objetivos = JSON.parse(temp);
  }

}
